<template>
  <label class="switch">
    <input
      v-model="toggleValue"
      type="checkbox"
      :disabled="isToggling"
      @click="setComputeWeekdayEnabled"
    />
    <span class="slider round"></span>
  </label>
</template>

<script>
import { mapActions } from 'vuex'
import Analytics from '@/lib/analytics'

export default {
  name: 'ComputeLiteDailyToggle',
  props: {
    modelId: {
      type: String,
      required: true,
      default: null,
    },
    modelName: {
      type: String,
      required: true,
    },
    dailyTriggersEnabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      toggleValue: this.dailyTriggersEnabled,
      isToggling: false,
    }
  },
  methods: {
    ...mapActions(['showSnackBar']),
    async setComputeWeekdayEnabled() {
      try {
        this.isToggling = true

        Analytics.track('compute', {
          action: `daily compute ${this.toggleValue ? 'disabled' : 'enabled'}`,
        })

        await this.$client.setComputeWeekdayEnabled({
          modelId: this.modelId,
          dailyTriggerEnabled: !this.toggleValue,
        })
      } catch (err) {
        this.toggleValue = !this.toggleValue
        console.error(err)
        this.showSnackBar({
          msg: `Unable to set daily trigger for model
                ${this.modelName}. Please contact support.`,
          time: 3000,
        })
        return
      } finally {
        this.isToggling = false
      }
      let snackMsg = this.toggleValue
        ? `Daily triggers enabled for model ${this.modelName}`
        : `Daily triggers disabled for model ${this.modelName}`
      this.showSnackBar({
        msg: snackMsg,
        time: 3000,
      })
    },
  },
}
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 23px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
